/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { labels } from '@umati/dashboard-common';
import { getInfoWindow } from './CustomInfoWindow';
import ENVs from 'utilities/ENVs';
import { connect } from 'react-redux';
import { watermarkedBucketReachable } from 'redux/selectors';

export const getInner = (name, onMouseLeave, img, children, path, watermarkedBucketReachable, altImg = <></>) => {
  return (
    <div className="pin-info text-center" onMouseLeave={onMouseLeave}>
      <div className="pin-info-head mb-2">
        <span className="h5">{name}</span>
      </div>
      <div className="pin-info-body">
        <div className="pin-info-logo mb-2">
          <img
            src={img}
            onError={(error) => {
              error.target.onerror = null;
              error.target.src = `${ENVs.WatermarkedBucketUrl(watermarkedBucketReachable)}/watermarked/test-image.jpg`;
            }}
            alt=""
          />
          {altImg}
        </div>
        {children}
        <Link to={path}>
          <button className="btn btn-sm btn-outline-primary">{labels.showMore}</button>
        </Link>
      </div>
    </div>
  );
};

class SwInfoWindow extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const inner = getInner(
      this.props.name,
      this.props.onMouseLeave,
      this.props.iconUrl,
      this.props.children,
      this.props.Path,
      this.props.watermarkedBucketReachable,
    );
    return getInfoWindow(this.props, inner);
  }
}

const mapStateToProps = (state) => {
  return {
    watermarkedBucketReachable: watermarkedBucketReachable(state) || false,
  };
};

export default connect(mapStateToProps)(SwInfoWindow);
